export default __webpack_public_path__ + "static/media/default_image.7fcb32db.svg";